
import Vue from 'vue';

export function httpGetFaxian(data) {
  return  Vue.$axios({
    url: '/api/wallet/discovery/all',
    method: 'post',
    data
  })
}

export function httpGetFaxianByType(data) {
  return  Vue.$axios({
    url: '/api/wallet/discovery/lists',
    method: 'post',
    data
  })
}

